import work1 from '../../assets/movie.jpg'
import work2 from '../../assets/work13.jpg'
import work3 from '../../assets/work11.jpg'
import work4 from '../../assets/work9.jpg'
import work5 from '../../assets/work14.jpg'
import work6 from '../../assets/work10.jpg'
import work7 from '../../assets/book.jpg'
import work8 from '../../assets/student.png'
import work9 from '../../assets/country.png'
import work10 from '../../assets/expence.png'
import work11 from '../../assets/todo.png'
import work12 from '../../assets/work20.jpg'
import work13 from '../../assets/work21.jpg'
import work14 from '../../assets/git_repo.jpg'

export const projectsData = [
    {
        id: 1,
        image: work12,
        title: 'Tic Tac Toe',
        category: 'Javascripts',
        link: 'https://pra-tic-tac.netlify.app/',
    },

    {
        id: 2,
        image: work2,
        title: 'Snake Game',
        category: 'Javascripts',
        link: "https://pk-sanke-game.netlify.app/"

    },
    {
        id: 3,
        image: work3,
        title: 'Ai Chat-boat',
        category: 'React',
        link: "https://prabhat-kumar.netlify.app/"

    },
    {
        id: 4,
        image: work4,
        title: 'Realtime Chat Application',
        category: 'React',
        link: 'https://pk-chat-app.netlify.app/',
    },
    {
        id: 5,
        image: work5,
        title: 'calculater',
        category: 'React',
        link: "https://calculator-by-prabhat.netlify.app/"

    },
    {
        id: 6,
        image: work6,
        title: 'Flappy Birds',
        category: 'Javascripts',
        link: 'https://flappy-birds-by-pk.netlify.app/',
    },
    {
        id: 7,
        image: work7,
        title: 'Book Lister',
        category: 'Javascripts',
        link: 'https://pk-books-list.netlify.app/',
    },
    {
        id: 8,
        image: work8,
        title: 'Student Portal',
        category: 'Javascripts',
        link: 'https://students-portal.netlify.app/',
    },
    {
        id: 9,
        image: work9,
        title: 'Country Guide App',
        category: 'Javascripts',
        link: 'https://countrys-guide-app.netlify.app/',
    },
    {
        id: 10,
        image: work10,
        title: 'Expence-calculator',
        category: 'Javascripts',
        link: 'https://ex-calculator.netlify.app/',
    },
    {
        id: 11,
        image: work11,
        title: 'Todo App',
        category: 'React',
        link: 'https://pk-todo-application.netlify.app/',
    },
    {
        id: 12,
        image: work13,
        title: 'Currency converter',
        category: 'Javascripts',
        link: "https://pra-currency-con.netlify.app/"
    },
    {
        id: 13,
        image: work1,
        title: 'Movie list',
        category: 'React',
        link: "https://pk-movie-list.netlify.app/"
    },
    {
        id: 14,
        image: work14,
        title: 'Git repo',
        category: 'React',
        link: "https://git-listing-repo.netlify.app/"
    }


];

export const projectsNav = [
    {
        name: 'all',
    },
    {
        name: 'Javascripts',
    },
    {
        name: 'React',
    },

]